import { ROUTES, ERoutes } from 'src/constants';

export const getRouteByPath = (pathname: string): ERoutes => {
  for (const [key, value] of Object.entries(ROUTES)) {
    if (pathname.includes(value)) return key as ERoutes;
  }
  return ERoutes.OPEN_AI_COMMON_FILES;
};
